import { MainApi } from "../../../../services/mainApi.service";

import { IIpmTasyRelationships } from "../../../../models/ipm-tasy";
import { RelationShipScreen } from "../../../../screens/RelationshipsScreens/RelationShipScreen";

const ACCESS_TOKEN_ROUTE =
  process.env.REACT_APP_4UBUS + "/api/v1/EstablishmentSetRelationships/";
const accessTokenService = new MainApi<IIpmTasyRelationships>(
  ACCESS_TOKEN_ROUTE,
);

const RelationShipPage = () => {
  return (
    <RelationShipScreen<IIpmTasyRelationships> service={accessTokenService} />
  );
};

export default RelationShipPage;
